import RecapRecentlyViewed from 'components/Content/Recap/RecapRecentlyViewed/RecapRecentlyViewed';

export default RecapRecentlyViewed;
